import { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Button from "../Other/element/Button"; // Adjust the import path as necessary

const ResourceCard = ({ type, title, image, author, authorImage }) => {
  const { t } = useTranslation();
  return (
    <div className="flex gap-4 bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow">
      <div className="w-24 h-24 flex-shrink-0">
        <img
          src={`${process.env.REACT_APP_COURSE_API_BASEURL}${image}` || "/placeholder.svg"}
          // src={image} // Use public path directly
          alt={title}
          className="w-full h-full object-cover rounded-md"
        />
      </div>
      <div className="flex flex-col flex-1">
        <span className="text-blue-500 text-sm font-medium mb-2">
          {t(type)}
        </span>
        <h3 className="text-gray-900 font-semibold mb-2 line-clamp-2">
          {t(title)}
        </h3>
        {author && (
          <div className="flex items-center gap-2">
            <img
              // src={`${process.env.REACT_APP_COURSE_API_BASEURL}${authorImage}` || "/placeholder.svg"}
              src={authorImage} // Use public path directly
              alt={author}
              className="w-6 h-6 rounded-full"
            />
            <span className="text-gray-600 text-sm">{t(author)}</span>
          </div>
        )}
      </div>
    </div>
  );
};

const FeaturedResource = ({ title, subtitle, image }) => {
  const { t } = useTranslation();
  return (
    <div className="bg-blue-600 rounded-lg p-8 text-white">
      <img
        // src={`${process.env.REACT_APP_COURSE_API_BASEURL}${image}` || "/placeholder.svg"}
        src={image} // Use public path directly
        alt={title}
        className="w-full max-w-md mx-auto mb-6"
      />
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-4 max-w-2xl mx-auto">
        {t(title)}
      </h2>
      <p className="text-center text-blue-100 mb-8 max-w-xl mx-auto">
        {t(subtitle)}
      </p>
      <div className="flex justify-center items-center ">
        <div className="bg-blue-500 hover:bg-blue-400 flex items-center ps-3 rounded-lg">
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
            />
          </svg>
          <Button
            title="Download whitepaper"
            className="bg-blue-500 hover:bg-blue-400 text-white pe-6 py-3 rounded-lg flex items-center gap-2 transition-colors"
          ></Button>
        </div>
      </div>
    </div>
  );
};

export default function EnterpriseResources() {
  const [resources, setResources] = useState({
    featured: {},
    sidebar: [],
  });
  const { t } = useTranslation();
  useEffect(() => {
    async function fetchReasonsData() {
      try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/enterprises`);
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("API Response:(((((((((", events);
        setResources(events);  // turns string into array of objects
      }
      catch (error) {
        console.error("Error fetching reasons data:", error);
      }
    }
    fetchReasonsData();
  }, []);

  return (
    <div className=" bg-[#ffffff] max-w-full">
      <div className="max-w-5xl mx-auto px-4 py-12">
        <h1 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
          {t("enterpriseResources.heading", "Enterprise Resources")}
        </h1>

        <div className="grid lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <FeaturedResource {...resources.featured} />
          </div>

          <div className="space-y-4 lg:col-span-2">
            {resources.sidebar.map((resource, index) => (
              <ResourceCard key={index} {...resource} />
            ))}

            <div className="text-end py-8">
              <Button
                title="View all"
                className="border border-blue-500 text-blue-500 font-bold px-8 py-2 bg-white rounded-md hover:bg-blue-100"
                backgroundColor="white"
                textColor="blue"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
